import { render, staticRenderFns } from "./CustomerImportCampaignStatus.vue?vue&type=template&id=23012fce&scoped=true&"
import script from "./CustomerImportCampaignStatus.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportCampaignStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportCampaignStatus.vue?vue&type=style&index=0&id=23012fce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23012fce",
  null
  
)

export default component.exports